import { render } from "./DashboardUpdateBusiness.vue?vue&type=template&id=f86a48d4&scoped=true"
import script from "./DashboardUpdateBusiness.vue?vue&type=script&lang=js"
export * from "./DashboardUpdateBusiness.vue?vue&type=script&lang=js"

import "./DashboardUpdateBusiness.vue?vue&type=style&index=0&id=f86a48d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f86a48d4"]])

export default __exports__